module.exports = __webpack_public_path__ + "img/red.677db2cf.svg";